import { setSelectedDealer } from "components";
import { DealersAndLocationsDropdownKeys } from "components/DealersAndLocationsDropdown/queryKeys";
import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";

import type { Dealer } from "models";
import type { DefaultReportThreshold } from "modules/DealerOverviewDashboard/components/DmsSystem/components/ThresholdSettings/hooks";

export type DealerOverviewFormPayload = Pick<
  Dealer,
  | "name"
  | "city"
  | "street"
  | "postal_code"
  | "phone_nr"
  | "website_url"
  | "region"
  | "country_code"
  | "sys_admin_name"
  | "sys_admin_email"
  | "sys_admin_phone"
  | "dms_server_info"
  | "network_info"
  | "domain_name"
  | "is_snooze_type_next_visit_customer_enabled"
  | "is_snooze_type_remind_customer_enabled"
  | "is_snooze_type_make_new_appointment_enabled"
  | "is_snooze_type_make_offer_enabled"
  | "is_snooze_status_enabled"
  | "is_snooze_department_enabled"
  | "is_snooze_attachment_enabled"
  | "enabled_warranty_types"
  | "web_clock_url"
  | "is_xentry_enabled"
  | "sms_gateway_id"
  | "twilio_account_sid"
  | "twilio_api_key"
  | "twilio_phone_number"
  | "twilio_monthly_dollar_limit"
  | "twilio_monthly_sms_limit"
  | "planit_planning_enabled"
  | "planit_planning_user_name"
  | "onei_planning_enabled"
  | "onei_planning_environment_guid"
> & {
  dealer_report_thresholds: DefaultReportThreshold[];
  xentry_client_id?: string;
  xentry_client_secret?: string;
  twilio_auth_token?: string;
  twilio_api_secret?: string;
  planit_planning_password?: string;
  onei_planning_api_key?: string;
};

export const useUpdateDealerMutation = () =>
  useTypedMutation({
    mutationFn: async (payload: Dealer) => (await ApiInstance.post("/dealers/update", payload, ENV.dealerBaseURL)).data,
    onSuccess: payload => {
      const dealersList = typedQueryClient.getQueryData(DealersAndLocationsDropdownKeys.dealers);
      const dealerIdx = dealersList?.dealers.findIndex(dealer => dealer.id === payload.id) ?? -1;

      if (dealersList && dealerIdx !== -1)
        typedQueryClient.setQueryData(DealersAndLocationsDropdownKeys.dealers, {
          ...dealersList,
          dealers: dealersList.dealers.with(dealerIdx, { ...dealersList.dealers[dealerIdx], ...payload })
        });

      const selectedDealer = typedQueryClient.getQueryData(DealersAndLocationsDropdownKeys.selectedDealer);
      if (!selectedDealer) return;

      setSelectedDealer({ ...selectedDealer, ...payload });
    }
  });
